export default {
  lineNumberColor: `#cccccc`,
  lineNumberBgColor: `#2d2d2d`,
  backgroundColor: `#2d2d2d`,
  textColor: `#cccccc`,
  substringColor: `#cccccc`,
  keywordColor: `#cc99cc`,
  attributeColor: `#ffcc66`,
  selectorAttributeColor: `#cc99cc`,
  docTagColor: `#cccccc`,
  nameColor: `#f2777a`,
  builtInColor: `#f99157`,
  literalColor: `#f99157`,
  bulletColor: `#99cc99`,
  codeColor: `#cccccc`,
  additionColor: `#99cc99`,
  regexpColor: `#f2777a`,
  symbolColor: `#99cc99`,
  variableColor: `#f2777a`,
  templateVariableColor: `#f2777a`,
  linkColor: `#f99157`,
  selectorClassColor: `#f2777a`,
  typeColor: `#f99157`,
  stringColor: `#99cc99`,
  selectorIdColor: `#f2777a`,
  quoteColor: `#999999`,
  templateTagColor: `#cccccc`,
  deletionColor: `#f2777a`,
  titleColor: `#6699cc`,
  sectionColor: `#6699cc`,
  commentColor: `#999999`,
  metaKeywordColor: `#cccccc`,
  metaColor: `#f99157`,
  functionColor: `#cccccc`,
  numberColor: `#f99157`,
}
